module.exports = __webpack_public_path__ + "img/chat-avatar.bd39cb3a.svg";